import BasePage from '../../components/base-page/base-page';
import Carousel from '../../components/carousel/carousel';
import VideoModal from '../../components/video-modal/video-modal';
import '../../components/_review-articles.scss';

import breakpoints from '../../config/breakpoints';

import './home.scss';

class HomePage extends BasePage {
  ui = {
    testimonialsCarousel: '.js-testimonials-carousel',
    demoSetapp: '.js-demo-setapp',
    promoAppsSection: '.js-promo-apps-section',
    promoAppsSelect: '.js-promo-apps-select',
    headerDemoSetapp: '.js-header-demo-setapp',
    homeDemoContainer: '.home-demo__container',
    homeHeader: '.home-header',
  };

  uiCollections = {
    promoAppsCollections: '.js-promo-apps-collection',
    promoAppsRadioSwitcher: '.js-promo-apps-radio-switcher',
  };

  events = {
    'click @uiCollections.promoAppsRadioSwitcher': 'handlePromoAppCollectionSelect',
    'change @ui.promoAppsSelect': 'handlePromoAppCollectionSelect',
  };

  collectionsBgClasses = {
    enhanceMac: 'promo-apps_bg-green',
    elevateWork: 'promo-apps_bg-blue',
    optimizeLife: 'promo-apps_bg-purple',
    ios: 'promo-apps_bg-dirty-purple',
  };

  onInit() {
    super.onInit();

    this.testimonialsCarousel = new Carousel({
      rootElement: this.ui.testimonialsCarousel,
      slidesPerPage: {
        [breakpoints.sm]: 2,
        [breakpoints.lg]: 3,
      },
    }).init();

    const headerDemoSetappObserver = new IntersectionObserver(this.handleHeaderDemoSetappIntersection);
    headerDemoSetappObserver.observe(this.ui.headerDemoSetapp);

    const demoSetappObserver = new IntersectionObserver(this.handleDemoSetappIntersection);
    demoSetappObserver.observe(this.ui.demoSetapp);

    new VideoModal().init();
    this.videoTestimonialsCarousel = new Carousel({
      rootElement: '.video-testimonials',
      baseClass: 'video-testimonials',
    });
    this.videoTestimonialsCarousel.init();
  }

  handleDemoSetappIntersection = (entries) => {
    entries.forEach((entry) => {
      this.ui.demoSetapp.classList.toggle('home-demo__setapp_visible', entry.isIntersecting);
    });
  };

  handleHeaderDemoSetappIntersection = (entries) => {
    entries.forEach((entry) => {
      this.ui.headerDemoSetapp.classList.toggle('home-header__setapp_visible', entry.isIntersecting);
    });
  };

  handlePromoAppCollectionSelect(e) {
    this.selectActivePromoCollection(e.currentTarget.value);
  }

  selectActivePromoCollection(collectionName) {
    // keep radio buttons and select in sync
    this.ui.promoAppsSelect.value = collectionName;
    this.uiCollections.promoAppsRadioSwitcher.forEach((radioButton) => {
      // eslint-disable-next-line no-param-reassign
      radioButton.checked = radioButton.value === collectionName;
    });

    const bgClasses = Object.keys(this.collectionsBgClasses)
      .map(key => this.collectionsBgClasses[key]);
    this.ui.promoAppsSection.classList.remove(...bgClasses);
    this.ui.promoAppsSection.classList.add(this.collectionsBgClasses[collectionName]);

    this.uiCollections.promoAppsCollections
      .forEach(collection => collection.classList.toggle('d-none', collection.dataset.collection !== collectionName));
  }
}

export default HomePage;

HomePage.initOnDomLoaded();
